/*
 *   部门、公司、值列表、供应商  的 选择历史 mixin
 *   后端文档：https://www.yuque.com/docs/share/99b8b382-d6ef-494e-87bc-c451b906b5d7
 *
 * */

import { getHistory, deleteHistory, addHistory } from 'api/history';

export default {
  data() {
    return {
      historyList: [],
    };
  },
  watch: {
    showValueList(val) {
      const { useWatch = false, shouldUseHistory } = this;
      if (useWatch && val && shouldUseHistory) {
        this.getHistoryData();
      }
    },
  },
  created() {
    const { useWatch = false } = this;
    if (!this.shouldUseHistory || useWatch) return;
    this.getHistoryData();
  },
  computed: {
    // 因为表单这边 用的是 <select-simple-list /> 组件 这个是有和其他共用的
    // 所以 校验下 是否有 methodCaller 且里面的source 的 messageKey 为 select_company
    shouldUseHistory() {
      const { useHistory, methodCaller = {}, entityName, useHistoryList } = this;
      const { source = {} } = methodCaller;
      if (methodCaller && methodCaller.source) {
        return source.messageKey === 'select_company' && useHistory;
      } else {
        if (entityName === 'CUSTOM_ENUMERATION') return !!useHistoryList;
        else return useHistory;
      }
    },
  },
  methods: {
    addHistoryData(data, array = false) {
      if (!this.shouldUseHistory) return;
      const { keyName, saveParams = {} } = this;
      let params = {
        entityName: this.entityName,
        objectOIDs: [],
        ...saveParams,
      };
      if (array) {
        data.forEach((item) => {
          params.objectOIDs.push(item[keyName]);
        });
      } else {
        params.objectOIDs.push(data[keyName]);
      }
      addHistory(params);
    },
    getHistoryData() {
      const { getParams = {} } = this;
      getHistory({ entityName: this.entityName, ...getParams })
        .then((res) => {
          let data = res.data || [];
          if (this.entityName === 'DEPARTMENT') {
            //部门 需要 额外的 过滤处理
            if (this.useEntity) {
              //虚拟部门过滤
              data = data.filter((dep) => dep.isEntity);
            }
            if (this.onlyLeafEnable) {
              //非叶子部门过滤
              data = data.filter((dep) => !dep.hasChildrenDepartments);
            }
          } else if (this.entityName === 'CUSTOM_ENUMERATION') {
            if (this.onlyLeafEnable) {
              data = data.filter((item) => item.leaf);
            }
          } else if (this.entityName === 'VENDOR') {
            data = data.map((item) => {
              return {
                dataType: 'SUPPLIER',
                id: item.id,
                vendorInfoOID: item.vendorInfoOID,
                companyOID: item.companyOid,
                abstractNumber: item.venNickOid,
                name: item.venNickname,
                notes: item.notes,
                supplierType: item.venderTypeName,
                value: item.venNickname,
                extra1: item.departmentName,
                extra2: item.companyName,
                venType: item.venType,
              };
            });
          }
          this.historyList = data;
        })
        .catch(() => {
          this.historyList = [];
        });
    },
    clearHistory() {
      this.historyList = [];
      const { keyName, saveParams = {} } = this;
      const params = {
        entityName: this.entityName,
        objectOIDs: this.historyList.map((item) => item[keyName]),
        ...saveParams,
      };
      deleteHistory(params)
        .then(() => {
          // this.historyList = [];
        })
        .catch(() => {
          // this.historyList = [];
        });
    },
  },
};
